"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Subject_1 = require("rxjs/Subject");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
var path = require("path");
var operators_1 = require("rxjs/operators");
var EditorImportDocumentPopupComponent = /** @class */ (function () {
    function EditorImportDocumentPopupComponent(data, kbService, exportTemplatesService, dialogRef) {
        this.data = data;
        this.kbService = kbService;
        this.exportTemplatesService = exportTemplatesService;
        this.dialogRef = dialogRef;
        this.isValid = {
            extension: true,
            size: true
        };
        this.importedFile = null;
        this.destroy$ = new Subject_1.Subject();
        this.allowedExtensions = ['docx'];
    }
    EditorImportDocumentPopupComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    EditorImportDocumentPopupComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    EditorImportDocumentPopupComponent.prototype.save = function () {
        this.dialogRef.close(this.htmlResult);
    };
    EditorImportDocumentPopupComponent.prototype.onFileSelected = function (event) {
        this.importFile(event.target.files[0]);
    };
    EditorImportDocumentPopupComponent.prototype.onDrop = function (event) {
        event.preventDefault();
        var uploadedFile;
        if (event.dataTransfer.items) {
            uploadedFile = event.dataTransfer.items[0].getAsFile();
        }
        else {
            uploadedFile = event.dataTransfer.files[0];
        }
        this.importFile(uploadedFile);
    };
    EditorImportDocumentPopupComponent.prototype.onDragOver = function (event) {
        event.preventDefault();
    };
    EditorImportDocumentPopupComponent.prototype.onDragLeave = function (event) {
        event.preventDefault();
    };
    EditorImportDocumentPopupComponent.prototype.cancelFile = function () {
        this.isFileImported = false;
        this.isValid = {
            extension: true,
            size: true
        };
        this.importedFile = null;
    };
    EditorImportDocumentPopupComponent.prototype.importFile = function (file) {
        var _this = this;
        this.importedFile = file;
        this.isValid = this.validate(file);
        if (this.isValid.extension && this.isValid.size) {
            this.isUploadInProgress = true;
            var extension = path.extname(file.name.toLowerCase()).slice(1);
            this.exportTemplatesService.convert(file, extension)
                .pipe(operators_1.takeUntil(this.destroy$))
                .subscribe(function (resultHTML) {
                _this.isUploadInProgress = false;
                _this.isFileImported = true;
                _this.fileName = file.name;
                _this.htmlResult = resultHTML;
            });
        }
    };
    EditorImportDocumentPopupComponent.prototype.validate = function (file) {
        return {
            extension: this.allowedExtensions.some(function (extension) { return file.name.toLowerCase().endsWith(extension.toLowerCase()); }),
            size: file.size < 3145728 // 3 MB
        };
    };
    EditorImportDocumentPopupComponent = __decorate([
        core_1.Component({
            selector: 'sis-template-editor-import-document-popup',
            template: require('./editor-import-document-popup.component.html'),
            styles: [require('./editor-import-document-popup.component.css')]
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, idm_kb_service_client_js_1.KbService,
            idm_export_templates_service_client_js_1.ExportTemplatesService,
            material_1.MatDialogRef])
    ], EditorImportDocumentPopupComponent);
    return EditorImportDocumentPopupComponent;
}());
exports.EditorImportDocumentPopupComponent = EditorImportDocumentPopupComponent;
//# sourceMappingURL=editor-import-document-popup.component.js.map